import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/icon/iconfont.css'
import './assets/iconTwo/iconfont.css'

Vue.config.productionTip = false

import './permission' //挂载权限路由守卫

import dictionaries from '@/utils/dictionaries/dictionaries.js' //字典项
import dictInfo from '@/utils/dictionaries/dictInfo.js' //字典项
import commonUtils from '@/utils/commonUtils.js'
Vue.prototype.dictionaries = dictionaries //全局挂载工具字典项
Vue.prototype.dictInfo = dictInfo //后台自动生成的字典项
Vue.prototype.commonUtils = commonUtils //全局挂载工具类

import echarts from 'echarts'
Vue.prototype.echarts = echarts

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' // 默认主题
import './style/theme/index.css' // 导入自定义主题
Vue.use(ElementUI)


new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
